module.exports = __webpack_public_path__ + "fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot
// module id = 1117
// module chunks = 8